// extracted by extract-css-chunks-webpack-plugin
module.exports = {"media":"css-178D9lEgk7","media_item":"css-3NQ9lzoCcJ"};